import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import css from './customPlanModal.module.css';
import { useTranslation } from 'react-i18next';

const CustomPlanModal = ({ isOpen, onClose, authUser}) => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  // Handle visibility with delay for animation
  useEffect(() => {
    if (isOpen) {
      // First make visible (mounts the DOM)
      setIsVisible(true);
      // Then trigger animation after a tiny delay
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setShouldAnimate(true);
        });
      });
    } else {
      // Remove animation class immediately
      setShouldAnimate(false);
      // Delay removal to allow exit animation
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 300); // Match transition duration
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Close modal with Escape key and handle body scroll
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Small delay to prevent layout shift during animation
      requestAnimationFrame(() => {
        document.body.style.overflow = 'hidden';
      });
    } else {
      // Delay scrollbar restoration until after exit animation completes
      const timer = setTimeout(() => {
        document.body.style.overflow = 'unset';
      }, 300); // Match transition duration
      
      return () => {
        clearTimeout(timer);
        document.removeEventListener('keydown', handleEscape);
      };
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };



  if (!isVisible) return null;

  return (
    <>
      {/* Popup Overlay */}
      <div 
        className={`${css.popupOverlay} ${shouldAnimate ? css.active : ''}`} 
        onClick={handleOverlayClick}
      >
        <div className={css.popupContainer} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className={css.popupHeader}>
            <div className={css.popupTitle}>
              <div className={css.popupIcon}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                  <path d="M16 7v-2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"></path>
                  <line x1="9" y1="11" x2="9" y2="14"></line>
                  <line x1="15" y1="11" x2="15" y2="14"></line>
                </svg>
              </div>
              B2B
            </div>
            <button className={css.closeBtn} onClick={onClose}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className={css.popupContent}>
            <form className={css.customPlanForm} action="">
                <div className={css.formGroup}>
                    <label htmlFor="name">{t("Name")}:</label>
                    <input type="text" id="name" name="name" required />
                </div>
                <div className={css.formGroup}>
                    <label htmlFor="email">{t("Email")}:</label>
                    <input type="email" id="email" name="email" required />
                </div>
                <div className={css.formGroup}>
                    <label htmlFor="phone">{t("Phone")}:</label>
                    <input type="tel" id="phone" name="phone" />
                </div>
                <div className={css.formGroup}>
                    <label htmlFor="message">{t("Message")}:</label>
                    <textarea id="message" name="message" rows="4"></textarea>
                </div>
                <div className={css.buttonCon}>
                    <button type="submit" className={css.submitBtn}>{t("Submit")}</button>
                </div>
            </form>
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      <div className={`${css.toast} ${showToast ? css.show : ''}`}>
        <div className={css.toastIcon}>✓</div>
        <span>{toastMessage}</span>
      </div>
    </>
  );
};

export default CustomPlanModal;